var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "edit-dialog",
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            width: "70%",
            "modal-append-to-body": true,
            "append-to-body": "",
            "close-on-click-modal": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            closed: _vm.handleClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
                "label-position": "right",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "策略名称", prop: "name", required: "" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入策略名称",
                      maxlength: "100",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("弹窗配置"),
              ]),
              _vm._l(_vm.form.popupConfigs, function (config, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "popup-config-item" },
                  [
                    _c(
                      "div",
                      { staticClass: "popup-config-header" },
                      [
                        _c("span", { staticClass: "config-title" }, [
                          _vm._v("弹窗配置 " + _vm._s(index + 1)),
                        ]),
                        index > 0
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "danger",
                                  size: "small",
                                  icon: "el-icon-delete",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removePopupConfig(index)
                                  },
                                },
                              },
                              [_vm._v("\n            删除\n          ")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "弹窗类型",
                          prop: `popupConfigs.${index}.popupType`,
                          required: index === 0,
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请选择弹窗类型" },
                            model: {
                              value: config.popupType,
                              callback: function ($$v) {
                                _vm.$set(config, "popupType", $$v)
                              },
                              expression: "config.popupType",
                            },
                          },
                          _vm._l(_vm.popupTypeOptions, function (option) {
                            return _c("el-option", {
                              key: option.id,
                              attrs: { label: option.value, value: option.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "弹窗标题",
                          prop: `popupConfigs.${index}.popupTitle`,
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "弹窗标题文案",
                            maxlength: "50",
                            "show-word-limit": "",
                          },
                          model: {
                            value: config.popupTitle,
                            callback: function ($$v) {
                              _vm.$set(config, "popupTitle", $$v)
                            },
                            expression: "config.popupTitle",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "弹窗描述",
                          prop: `popupConfigs.${index}.popupContent`,
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "弹窗描述文案",
                            maxlength: "200",
                            "show-word-limit": "",
                          },
                          model: {
                            value: config.popupContent,
                            callback: function ($$v) {
                              _vm.$set(config, "popupContent", $$v)
                            },
                            expression: "config.popupContent",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-plus",
                      },
                      on: { click: _vm.addPopupConfig },
                    },
                    [_vm._v("\n          添加弹窗配置\n        ")]
                  ),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("命中配置"),
              ]),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "渠道配置",
                    prop: "channelType",
                    required: "",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.handleChannelTypeChange },
                      model: {
                        value: _vm.form.channelType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "channelType", $$v)
                        },
                        expression: "form.channelType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("全部渠道"),
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("指定渠道"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.form.channelType === 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "指定渠道", prop: "appIds" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "80%" },
                        attrs: {
                          type: "textarea",
                          placeholder: "点击选择渠道",
                        },
                        on: { focus: _vm.channelInputClick },
                        model: {
                          value: _vm.form.appIds,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "appIds", $$v)
                          },
                          expression: "form.appIds",
                        },
                      }),
                      _c("channel-popups", {
                        attrs: {
                          isAppendToBody: true,
                          modelIsAppendToBody: false,
                          "app-id": _vm.form.channel.ids,
                          visible: _vm.channelVisible,
                          multiple: true,
                        },
                        on: {
                          "update:visible": function ($event) {
                            _vm.channelVisible = $event
                          },
                          comfirm: _vm.channelConfirm,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "应用版本",
                    prop: "versionRange",
                    required: "",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.handleVersionRangeChange },
                      model: {
                        value: _vm.form.versionRange,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "versionRange", $$v)
                        },
                        expression: "form.versionRange",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("全部版本"),
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("指定版本范围"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.form.versionRange === 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "版本范围", prop: "versionRangeInput" } },
                    [
                      _c("div", { staticClass: "version-range" }, [
                        _c("div", { staticClass: "version-input-container" }, [
                          _c(
                            "div",
                            { staticClass: "version-input-group" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small" },
                                  on: { click: _vm.decreaseMinVersion },
                                },
                                [_vm._v("-")]
                              ),
                              _c("el-input", {
                                staticStyle: {
                                  width: "160px",
                                  margin: "0 5px",
                                },
                                attrs: { placeholder: "0" },
                                on: { input: _vm.handleMinVersionInput },
                                model: {
                                  value: _vm.form.minClientVersion,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "minClientVersion", $$v)
                                  },
                                  expression: "form.minClientVersion",
                                },
                              }),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small" },
                                  on: { click: _vm.increaseMinVersion },
                                },
                                [_vm._v("+")]
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "version-label" }, [
                            _vm._v("最小版本"),
                          ]),
                        ]),
                        _c("div", { staticClass: "version-input-container" }, [
                          _c(
                            "div",
                            { staticClass: "version-input-group" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small" },
                                  on: { click: _vm.decreaseMaxVersion },
                                },
                                [_vm._v("-")]
                              ),
                              _c("el-input", {
                                staticStyle: {
                                  width: "160px",
                                  margin: "0 5px",
                                },
                                attrs: { placeholder: "0" },
                                on: { input: _vm.handleMaxVersionInput },
                                model: {
                                  value: _vm.form.maxClientVersion,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "maxClientVersion", $$v)
                                  },
                                  expression: "form.maxClientVersion",
                                },
                              }),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small" },
                                  on: { click: _vm.increaseMaxVersion },
                                },
                                [_vm._v("+")]
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "version-label" }, [
                            _vm._v("最大版本"),
                          ]),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "UID命中",
                    prop: "uidFilterType",
                    required: "",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.handleUidFilterTypeChange },
                      model: {
                        value: _vm.form.uidFilterType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "uidFilterType", $$v)
                        },
                        expression: "form.uidFilterType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v("不指定"),
                      ]),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("指定")]),
                      _c("el-radio", { attrs: { label: 2 } }, [_vm._v("排除")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.form.uidFilterType !== 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "UID列表", prop: "uidList" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "80%" },
                        attrs: {
                          placeholder: "多个用英文逗号隔开",
                          type: "textarea",
                        },
                        on: { blur: _vm.handleUidInput },
                        model: {
                          value: _vm.form.uidStr,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "uidStr", $$v)
                          },
                          expression: "form.uidStr",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("策略配置"),
              ]),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "展示跳转按钮",
                    prop: "showJumpButton",
                    required: "",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.handleShowJumpButtonChange },
                      model: {
                        value: _vm.form.showJumpButton,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "showJumpButton", $$v)
                        },
                        expression: "form.showJumpButton",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("展示")]),
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v("不展示"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.form.showJumpButton === 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "关联跳转", prop: "showJumpId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择关联跳转" },
                          model: {
                            value: _vm.form.showJumpId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "showJumpId", $$v)
                            },
                            expression: "form.showJumpId",
                          },
                        },
                        _vm._l(_vm.jumpOptions, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: `${item.id}-${item.name}`,
                              value: item.id,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "展示预留按钮",
                    prop: "showReservedButton",
                    required: "",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.handleShowReservedButtonChange },
                      model: {
                        value: _vm.form.showReservedButton,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "showReservedButton", $$v)
                        },
                        expression: "form.showReservedButton",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("展示")]),
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v("不展示"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.form.showReservedButton === 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "按钮标题", prop: "title" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入按钮标题" },
                        model: {
                          value: _vm.form.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "title", $$v)
                          },
                          expression: "form.title",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.form.showReservedButton === 1
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "事件类型",
                        prop: "eventType",
                        required: "",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择事件类型" },
                          model: {
                            value: _vm.form.eventType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "eventType", $$v)
                            },
                            expression: "form.eventType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "打开 H5", value: 1 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.form.showReservedButton === 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "事件响应" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入H5链接（可选）" },
                        model: {
                          value: _vm.form.eventAction,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "eventAction", $$v)
                          },
                          expression: "form.eventAction",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status", required: "" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("生效")]),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("失效")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "请输入备注（可选）",
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }